@use "variables" as *;

.button {
  position: relative;
  flex-shrink: 0;
}

.menuText {
  position: absolute;
  margin-bottom: -2px;
  bottom: 0;
  left: auto;
  right: auto;
  font-size: $fontSize-xxxs;
}

.icon {
  font-size: $fontSize-l;
}
